import { Navigate } from 'react-router-dom';

const RedirectToHome = () => {
    return <Navigate to={'/'} replace />;
};

export default RedirectToHome;